export default "__VITE_ASSET__gLpT03aS__"